import React from 'react'

function Host() {
  return (
    <div>  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.002 7.25977V11.5314"
      stroke="#A4A4A4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.1895 14.0527C11.1895 14.1563 11.1055 14.2402 11.002 14.2402C10.8984 14.2402 10.8145 14.1563 10.8145 14.0527C10.8145 13.9492 10.8984 13.8652 11.002 13.8652C11.1055 13.8652 11.1895 13.9492 11.1895 14.0527Z"
      fill="#202020"
      stroke="#A4A4A4"
    />
    <path
      d="M11.0016 19.4788C15.6845 19.4788 19.4808 15.6826 19.4808 10.9997C19.4808 6.31676 15.6845 2.52051 11.0016 2.52051C6.31871 2.52051 2.52246 6.31676 2.52246 10.9997C2.52246 15.6826 6.31871 19.4788 11.0016 19.4788Z"
      stroke="#A4A4A4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg></div>
  )
}

export default Host